import io from "socket.io-client";
import type { Socket } from "socket.io-client";
import { environment } from "../environments/environment";

const SOCKET_URL = environment.HOST_URL;

const socket: Socket = io(SOCKET_URL, {
  transports: ["websocket"],
  autoConnect: true,
  reconnectionAttempts: 20,
  reconnectionDelay: 5000,
});

socket.on("connect", () => {
  console.info("Socket connected successfully");
});

socket.on("disconnect", (reason: any) => {
  console.warn("Socket disconnected:", reason);
});

socket.on("connect_error", (err: any) => {
  console.error("Socket connection error:", err.message);
});

export default socket;
